import { HOW_IT_WORKS } from "@/content/copy";

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-20 lg:py-32 bg-navy text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-widest text-terracotta">{HOW_IT_WORKS.overline}</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">{HOW_IT_WORKS.title}</h2>
        </div>
        <ol className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 stagger">
          {HOW_IT_WORKS.steps.map((step, i) => (
            <li
              key={step.title}
              data-testid={`how-step-${i + 1}`}
              className="relative rounded-2xl bg-navy-light p-8 border border-white/10"
            >
              <span className="text-5xl font-extrabold text-terracotta" aria-hidden="true">{i + 1}</span>
              <h3 className="mt-4 text-xl font-semibold">{step.title}</h3>
              <p className="mt-3 text-sm text-white/70 leading-relaxed">{step.text}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
